// Lightweight logger for controlled diagnostics.
// Do not auto-report to Sentry here — most call sites are handled UI/API failures.
// Uncaught errors are captured by the Sentry SDK; use captureException() for unexpected cases.
export class Logger {
  static isEnabled() {
    try {
      if (typeof window !== 'undefined' && window.ASSISTGO_DEBUG === true) return true;
      if (typeof localStorage !== 'undefined' && localStorage.getItem('assistgo_debug') === '1') return true;
    } catch (_) {}
    return false;
  }
  static debug(...args) { if (Logger.isEnabled()) { console.debug('[AssistGo]', ...args); } }
  static warn(...args) { console.warn('[AssistGo]', ...args); }
  static error(...args) { console.error('[AssistGo]', ...args); }
}
